<!--核房人-支付人-入住名单--->
<template>
  <div class="checkList mt-4">
    <!--核房人-->
    <div class="nuclearRoom"  v-if="storeInfo.type==2&&$GFUN.isInArray([6,7,8],orderDetail.status)|| (storeInfo.type==3||isAdmin)&&orderDetail.verify_arr.length>0">
      <div class="nuclearRoom-title">
        核房人
        <div class="remark" v-if="storeInfo.type==2">
          <span>(对核房人酒店价格保密 )</span>
          <el-button @click="tourGuideStart(1)" class="addBtn" type="primary" plain icon="el-icon-plus" size="mini">添加</el-button>
        </div>
      </div>
      <!--核房人列表-->
      <ul class="tourGuideList">
        <li v-for="item in orderDetail.verify_arr" :key="item.id">
          <div class="name">{{item.title.charAt(0) }}</div>
          <div class="title">
            <div>{{ item.title }}<span class="content-label">{{item.flag | formatVar('PayerPeople')}}</span></div>
            <p><i class="el-icon-phone-outline mr-1"></i>{{ item.mob }}</p>
          </div>
          <div class="deleteBtn" v-if="storeInfo.type==2&&$GFUN.isInArray([6,7,8],orderDetail.status)">
            <el-button size="mini" @click="deleteTourGuide(item,1)">删除</el-button>
          </div>
        </li>
      </ul>
    </div>
    <!--支付人-->
    <div class="nuclearRoom" v-if="storeInfo.type==2&&$GFUN.isInArray([6,7,8],orderDetail.status)|| (storeInfo.type==3||isAdmin)&&orderDetail.pay_arr.length>0">
      <div class="nuclearRoom-title">
        支付人
        <div class="remark" v-if="orderDetail.pay_arr.length==0&&storeInfo.type==2">
          <span>(仅允许添加一位支付人 )</span>
          <el-button  @click="tourGuideStart(2)" class="addBtn" type="primary" plain icon="el-icon-plus" size="mini">添加</el-button>
        </div>
      </div>
      <ul class="tourGuideList">
        <li v-for="item in orderDetail.pay_arr" :key="item.id">
          <div class="name">{{item.title.charAt(0) }}</div>
          <div class="title">
            <div>{{ item.title }}<span class="content-label">{{item.flag | formatVar('PayerPeople')}}</span></div>
            <p><i class="el-icon-phone-outline mr-1"></i>{{ item.mob }}</p>
          </div>
          <div class="deleteBtn" v-if="storeInfo.type==2&&$GFUN.isInArray([6,7,8],orderDetail.status)">
            <el-button size="mini" @click="deleteTourGuide(item,2)">删除</el-button>
          </div>
        </li>
      </ul>
    </div>
    <!--入住名单-->
    <div class="nuclearRoom" v-if="storeInfo.type==2&&$GFUN.isInArray([6,7,8],orderDetail.status)||orderDetail.trip_title">
      <div class="nuclearRoom-title">
        入住名单
        <div class="remark" v-if="storeInfo.type==2&&!orderDetail.trip_title">
          <span>( doc、xls、jpg、png 格式)</span>
          <el-button class="addBtn" type="primary" plain icon="el-icon-plus" size="mini">
            上传
            <input class="file" type="file" accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.png,.jpeg" @change="chooseFile">
          </el-button>
        </div>
      </div>
      <ul class="tourGuideList" v-if="orderDetail.trip_title">
        <li  class="w-100">
          <div class="name"><i class="el-icon-date"></i></div>
          <div class="flsit">
            <p class="trip-title">{{ orderDetail.trip_title }}</p>
          </div>
          <div class="deleteBtn" v-if="storeInfo.type==2&&$GFUN.isInArray([6,7,8],orderDetail.status)">
            <el-button size="mini" @click="cut()">修改</el-button>
            <el-button size="mini" @click="deleteFile()">删除</el-button>
          </div>
          <div class="deleteBtn" v-else>
            <el-button size="mini" @click="toEleMsg()">查看</el-button>
          </div>
        </li>
      </ul>
    </div>
    <!--添加导游弹出框-->
    <el-drawer
      :title="tab==1?'添加核房人':'添加支付人'"
      :visible.sync="tourGuide"
      direction="rtl"
      :size="400"
      :z-index="8"
      >
      <!--导游搜索-->
      <div class="searchGuide">
        <el-input v-model="searchText" placeholder="请输入姓名/手机号" clearable></el-input>
        <el-button class="ml-2" type="primary"  @click="searchGuide">搜索</el-button>
      </div>
      <!--导游tab-->
      <div class="activeTab">
        <el-tabs v-model="formData.tab" @tab-click="tourGuideTab">
          <el-tab-pane label="导游" name="1"></el-tab-pane>
          <el-tab-pane label="领队" name="2"></el-tab-pane>
          <el-tab-pane label="预订人" name="3" v-if="tab==2"></el-tab-pane>
        </el-tabs>
      </div>
      <!--导游列表-->
      <div class="addGuide">
        <div class="total" v-if="list.length>0">共{{ list.length }}人</div>
        <el-button class="ml-2" type="primary" size="mini" @click="addGuide" >添加新{{formData.tab==1?'导游' : '领队'}}</el-button>
      </div>
      <!--导游列表-->
      <div class="scroll-wrap mt-1" ref="scrollBox">
        <!-- 加载状态 -->
         <ul>
          <li v-for="item in list" :key="item.oid">
            <div class="toux"><img :src="formData.tab==1?'/images/order/icon_23.png':'/images/order/icon_24.png'" alt=""></div>
            <div class="toux-title">
              <p>{{ item.title }}</p>
              <p class="mob">{{ item.mob }}</p>
            </div>
            <el-button class="toux-bottom" :disabled="$_Object.hasIdInArr(item.id,checkList,'id')" type="primary" size="mini" @click="addOrder(item)">{{$_Object.hasIdInArr(item.id,checkList,'id')?'已选':'添加'}}</el-button>
          </li>
         </ul>
        <div v-if="loading" class="load-tip">加载中...</div>
        <div v-if="noMore" class="load-tip">没有更多了</div>
      </div>
    </el-drawer>
    <!--添加导游弹出框-->
    <el-dialog 
        :visible.sync="addGuideShow" 
        width="500px"
        :z-index="9"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        center 
    >
    <div class="dialog-title">添加新人</div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="身份" >
          <el-radio-group v-model="formData.tab">
            <el-radio label="1">导游</el-radio>
            <el-radio label="2">领队</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="姓名" prop="truename">
          <el-input v-model="ruleForm.truename"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input type="number" v-model="ruleForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="确认手机号" prop="mobile2">
          <el-input type="number" v-model="ruleForm.mobile2"></el-input>
        </el-form-item>
        <el-form-item class="addBottom">
          <el-button type="primary" @click="submitForm('ruleForm')">立即添加</el-button>
          <el-button @click="addGuideShow=false">关闭</el-button>
        </el-form-item>
    </el-form>
    </el-dialog>
    <!--修改名称弹窗-->
    <el-dialog 
      :visible.sync="updateGuideShow" 
      width="500px"
      :z-index="9"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center 
    >
      <div class="dialog-title">修改名称</div>
        <el-form :model="fileForm" :rules="rules" ref="fileForm" label-width="100px" class="fileform">
          <el-form-item label="" prop="trip_title">
            <el-input
                type="text"
                placeholder="请输入内容"
                v-model="fileForm.trip_title"
                maxlength="15"
                show-word-limit
              >
              </el-input>
          </el-form-item>
          <div class="addBottom mt-3">
            <el-button  @click="updateGuideShow=false"  class="bottom">返回</el-button>
            <el-button  @click="submitOrder('fileForm')"  type="primary" class="bottom"  >修改</el-button>
          </div>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { mapActions,mapGetters } from 'vuex'
import { debounce } from "lodash";
export default {
  name: 'OrderCheckList',
  components: {},
  props: {
    orderDetail:{
      type:Object,
      default:()=>{
        return {
          pay_arr:[],
          verify_arr:[],
        }
      }
    },
  },
  data() {
    return {
        tab:1,
        searchText:'',
        tourGuide:false,
        formData:{
          call:1,
          page:1,
          title:'',
          mobile:'',
          tab:'1',
          num:10,
        },
        list:[],              //导游列表
        checkList:[],          //已添加导游列表
        loading: false,
        noMore: false,
        //添加导游
        addGuideShow:false,
        ruleForm: {
          truename:'',
          mobile:'',
          mobile2:'',
        },
        //表单验证
        rules: {
          trip_title: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            { min: 1, max: 15, message: '请输入1-15个字符', trigger: 'blur' },
          ],
          truename: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
          mobile: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { min: 11, max: 11, message: '请输入正确的11位数字手机号', trigger: 'blur' },
          ],
          mobile2: [
            { required: true, message: '请输入确认手机号', trigger: 'blur' },
            { validator: (rule, value, callback) => {
              if (value !== this.ruleForm.mobile) {
                callback(new Error('请确认手机号与手机号不一致'));
              } else {
                callback();
              }
            }, trigger: 'blur' },
          ],
        },
        subscription: null,
        fileInfo:null,
        //修改名称
        updateGuideShow:false,
        fileForm:{
          trip_title:'',
        },
        format:'',                //文件后缀
    };
  },
  computed: {
    ...mapGetters(['storeInfo','isAdmin']),
  },
  watch: {},
  created() {
    if(this.tourGuide){
      this.handleClick();
      // 绑定滚动监听 
      this.$nextTick(() => {
        const box = this.$refs.scrollBox
        box.addEventListener('scroll', this.handleScroll)
      })
    }
  },
  mounted() {},
  methods: {
      ...mapActions(['POST_GuideList','POST_OrderHotelSetVerify','POST_OrderHotelSetVerify','POST_AddGuide','POST_OrderHotelDelPay','POST_OrderHotelRenameTrip']),
      //开始导游列表
      tourGuideStart(tab){
        this.tab=tab;   //添加方式
        this.tourGuide=true;
        this.checkList=tab==1?this.orderDetail.verify_arr:this.orderDetail.pay_arr;
        this.formData.tab="1";
        this.tourGuideTab();
      },
      // 滚动监听
      handleScroll() {
        const box = this.$refs.scrollBox
        // 可视高度 + 已滚动距离 >= 总高度 - 阈值(提前加载，比如20px)
        const isBottom = box.clientHeight + box.scrollTop >= box.scrollHeight - 20
        if (isBottom && !this.loading && !this.noMore) {
          this.page++
          this.getList()
        }
      },
      async handleClick() {
        this.loading = true
        //如果是预订人直接返回值不调用接口
        if(this.formData.tab=='3'){
          this.list = [{
            id:this.orderDetail.send_store_id,
            flag:100,
            title:this.orderDetail.send_name,
            mob:this.orderDetail.offer_mobile  
          }]
          return;
        }
        try {
          // 模拟接口
          let res = await this.POST_GuideList(this.formData);
          if (res.list.length < this.formData.num) {
            this.noMore = true
          } 
          //总数量
          this.total = res.total
          // 分页拼接数组
          this.list = [...this.list, ...res.list]
        } catch (err) {
          console.error(err)
        } finally {
          this.loading = false
        }
      },
      //搜索导游
      searchGuide: debounce(function(){
        const searchValue = this.searchText.trim(); // 去除首尾空格，避免空字符串/纯空格干扰
        const type=this.$_Tool.checkValueType(searchValue);
        if (type === 'number') {
          this.formData.mobile = searchValue
          this.formData.title = ''
        } else {
          this.formData.mobile = ''
          this.formData.title = searchValue
        }
        this.tourGuideTab();
      },500),
      //切换身份
      tourGuideTab(){
        this.formData.page=1;
        this.loading=false;
        this.noMore=false;
        this.list=[];
        this.handleClick();
      },
      //开始添加导游
      addGuide(){
        this.addGuideShow=true;
      },
      //添加导游
      submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            let res = await this.POST_AddGuide({data:this.ruleForm,tab:this.formData.tab});
            console.log(res);
            if(res.code=="00000"){
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.addGuideShow=false;
              this.tourGuideTab();
              this.ruleForm={
                truename:'',
                mobile:'',
                mobile2:'',
              }
            }else{
              this.$message({
                message: res.msg,
                type: 'error'
              });
            }
          } else {
            return false;
          }
        });
      },
      //添加订单导游
      async addOrder(item){
        let data={
          id:item.id,
          flag:item.flag,
          oid:this.orderDetail.oid,
        }
        let res = await this.POST_OrderHotelSetVerify({data:data,tab:this.tab});
        if(res.code=="00000"){
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.$emit('getorderDetail');
          this.tourGuide=false;
        }
      },
      //删除订单导游
      async deleteTourGuide(item,tab){
        let data={
          id:item.id,
          flag:item.flag,
          oid:this.orderDetail.oid,
        }
        // 确认删除
        this.$confirm('确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          // 确认删除后执行删除操作
          let res = await this.POST_OrderHotelDelPay({data:data,tab:tab});
          if(res.code=="00000"){
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.$emit('getorderDetail');
            this.tourGuide=false;
          }
        }).catch(() => {
          // 取消删除
        });
      },
      //上传文件到七牛
      async chooseFile(e) {
        if (e.target.files[0].size > 5 * 1024 * 1024) {
          this._alert('文件超过5M，请选择5M以内的文件',null,'error')
        } else this.fileInfo = e.target.files[0];
        let next = res => this.fileProgressNum = Number((res.total.percent).toFixed(2));
        let complete = res => this.saveFileName('file',res.key);
        let error = res => console.log(res);
        let observable = await this.$GFUN.UploadFileToQiniu(this.fileInfo);
        this.subscription = observable.subscribe(next, error, complete);
      },
      /*保存电子行程单*/
      async saveFileName(type,saveText) {
        const submitFun = async () => {
          let res = await this.$axios.post('/pc/Travel/OrderHotelSetTrip',{
            store_id: this.storeInfo.storeId,
            trip: saveText,
            oid: this.orderDetail.oid,
            trip_title: this.fileInfo.name
          });
          if (res.code === '00000') this._alert('电子入住名单已上传！',() => {
            this.fileProgressNum = 0;
            this.fileInfo = null;
            this.$emit('getorderDetail')
          })
        }
        submitFun();
      },
      //删除文件
      async deleteFile () {
        this._confirm('确定删除该文件么？',async () => {
          let res = await this.$axios.post('/pc/Travel/OrderHotelDelTrip',{
            store_id: this.storeInfo.storeId,
            oid: this.orderDetail.oid,
          });
          if (res.code === '00000') this._alert('删除成功！',() => this.$emit('getorderDetail'))
        })
      },
      // 截取文件后缀名
      cut () {
            let trip_title=this.orderDetail.trip_title;
            let arr=trip_title.split('.');
            this.fileForm.trip_title=arr[0];
            this.format=arr[1];
            this.updateGuideShow=true;
      },  
      //下载
      toEleMsg () {
        window.open(this.ImgPreUrl + this.orderDetail.trip,'_blank')
      },
      // 提交修改
      submitOrder(formName){
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            this.fileForm.trip_title=this.fileForm.trip_title+'.'+this.format;
            this.fileForm.oid=this.orderDetail.oid;
            let res = await this.POST_OrderHotelRenameTrip({data:this.fileForm});
            if(res.code=="00000"){
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.updateGuideShow=false;
              this.$emit('getorderDetail');
            }
          }
        });
      }
  },
  beforeDestroy() {
    // 销毁移除监听，防止内存泄漏
    const box = this.$refs.scrollBox
      // 先判断 dom 是否存在再解绑
    if (box) {
      box.removeEventListener('scroll', this.handleScroll)
    }
  },
};
</script>

<style lang="scss" scoped>
  .scroll-wrap {
    max-height: 1000px; /* 固定高度 */
    overflow-y: auto;
    width: 90%;
    padding: 10px 0;
    margin: 0 auto;
    li{
      background-color: var(--smtc-color-back);
      margin-bottom:12px;
      width: 90%;
      padding: 10px 5%;
      border-radius: 5px;
      display: flex;
      cursor: pointer;  
    }
    li:hover{
      background-color: var(--smtc-color-TextBackground-blue);
    }
    .toux{
      width: 50px;
      height: 50px;
      border-radius: 50%;
      overflow: hidden;
      background-color: #fff;
      img{
        width: 80%;
        height: 80%;
        display: block;
        margin: 0 auto;
        margin-top:10px; 
      }  
    }
  }
  .mob{
    margin-top: 5px;
  }
  .toux-title{
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 60px;
  }
  .toux-bottom{
    margin-left: auto;
    height: 30px;
    margin-top: 15px;
  }
  .load-tip{
    text-align: center;
    margin-top: 10px;
    color: #999;
  }
  .checkList{
    .nuclearRoom{
      width: 92%;
      border-radius: 6px;
      padding: 10px 4%;
      font-size: 14px;
      color: #333;
      background-color: #fff;
      margin-top:10px
    }
    .nuclearRoom:nth-child(1){
      margin-left: 0;
    }
    .nuclearRoom-title{
      line-height: 30px;
      font-weight: bold;
    }
  }
  .remark{
    float: right;
    display: flex;
    align-items: center;
    span{
      font-size: 12px;
      font-weight: normal;
      margin-right: 10px;
      color: #999;
    }
  }
  .searchGuide{
    display: flex;
    justify-content:space-between;
    width: 90%;
    margin: 0 auto;
  }
  .activeTab{
    width: 90%;
    margin: 12px auto;
  }
  .addGuide{
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    overflow: hidden;
    margin-bottom:12px;
  }
  .total{
    margin-right:auto;
    margin-top: 6px;
    margin-left:6px;
  }
  .dialog-title{
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 26px;
    text-align: center;
  }
  .addBottom{
    display: flex;
    justify-content: center;
  }
  .tourGuideList{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li{
      width: 44%;
      padding: 10px 2%;
      background-color: var(--smtc-color-back);
      border-radius: 6px;
      margin-top: 12px;
      display: flex;
      .name{
        background-color: var(--smtc-color-primary);
        color: #fff;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        border-radius: 50%;
        font-size: 16px;
      }
      .title{
        margin-left: 10px;
        line-height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        p{
          margin-top: 5px;
          color: #999;
          font-size: 12px;
        }
      }
    }
  }
  .deleteBtn{
    margin-left: auto;
    margin-top: 10px;
    display: flex;
    button{
      height: 30px;
    }
  }
  .content-label{
    padding: 4px 6px;
    font-size: 12px;
    background-color: #e8f4ff;
    color: #0698ff;
    text-align: center;
    margin-left: 4px;
    border-radius: 6px;
    font-weight: normal;
  }
  .addBtn{
    position: relative;
    input{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
  }
  .flsit{
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 14px;
    width: 65%;
    margin-left: 10px;
  }
  .trip-title{
    text-align: justify;
  }
  @media screen and (max-width: 2200px) {
    .tourGuideList li {
      width: 100%;
      font-size: 14px;
    }
}
</style>
<style>
  .fileform .el-form-item__content{
    margin-left: 0 !important;
  }
</style>